import React, { createContext, useContext, useReducer } from 'react';
import { DriverState, DriverAction } from './types';
import { driverReducer, initialState } from './driverReducer';

const DriverContext = createContext<{
  state: DriverState;
  dispatch: React.Dispatch<DriverAction>;
} | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export const useDriver = () => {
  const context = useContext(DriverContext);
  if (!context) {
    throw new Error('useDriver must be used within a DriverProvider');
  }
  return context;
};

export const DriverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(driverReducer, initialState);

  return (
    <DriverContext.Provider value={{ state, dispatch }}>
      {children}
    </DriverContext.Provider>
  );
};
